import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom, map } from 'rxjs';
import { ApiResponseModel, LoginResponse } from 'src/app/models';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthService {
  constructor(private http: HttpClient) {}

  /**
   * Email-based login. Identity is proven either by a GIS ID token
   * (credential) or, in the account-chooser flow, by the Google ACCESS token
   * alone — verified server-side (tokeninfo + aud). The access token also
   * feeds the central B4A MCP login-authorization check.
   */
  async loginWithGoogle(
    credential: string | null,
    accessToken?: string | null
  ): Promise<LoginResponse> {
    return await lastValueFrom(
      this.http
        .post<ApiResponseModel<LoginResponse>>(
          (environment.apiUrl ? environment.apiUrl : 'http://localhost:5000') +
            '/login/google',
          { credential: credential ?? null, accessToken: accessToken ?? null }
        )
        .pipe(map((data) => data.result))
    );
  }
}
